export enum BuildingOverlayType {
  NONE,
  PRIMARY,
  SECONDARY,
  ALLEY,
  PEDESTRIAN,
  WATER,
  REAR,
  SIDE
}

export function getPrettyFrontageType(value: number): string {
  return ['', 'Primary', 'Secondary', 'Alley', 'Pedestrian', 'Water', 'Rear', 'Side'][value];
}
